var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_43569",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_43569)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_43569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2554 106.511C82.6676 106.511 106.511 82.6676 106.511 53.2554C106.511 23.8433 82.6676 0 53.2554 0C23.8433 0 0 23.8433 0 53.2554C0 82.6676 23.8433 106.511 53.2554 106.511Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7294 60.0349C83.0139 50.7503 81.2639 33.9471 69.8206 22.5039C58.3774 11.0606 41.5742 9.31061 32.2896 18.5951C23.0051 27.8797 24.7551 44.6829 36.1984 56.1261C47.6416 67.5694 64.4448 69.3194 73.7294 60.0349Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1102 14.034L83.293 10.2168C80.085 7.0269 75.7448 5.23633 71.2207 5.23633C66.6967 5.23633 62.3565 7.0269 59.1484 10.2168L43.3181 26.0364L73.8232 51.4656L87.1102 38.1786C90.3001 34.9706 92.0907 30.6304 92.0907 26.1063C92.0907 21.5822 90.3001 17.2421 87.1102 14.034Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.898 67.8413C82.4413 57.298 82.4413 40.2039 71.898 29.6606C61.3547 19.1173 44.2606 19.1173 33.7173 29.6606C23.174 40.2039 23.174 57.298 33.7173 67.8413C44.2606 78.3846 61.3547 78.3846 71.898 67.8413Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4146 67.089C34.943 64.5605 34.943 60.461 32.4146 57.9325C29.8861 55.4041 25.7866 55.4041 23.2581 57.9325C20.7297 60.461 20.7297 64.5605 23.2581 67.089C25.7866 69.6174 29.8861 69.6174 32.4146 67.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0303 67.088C84.5588 64.5595 84.5588 60.46 82.0303 57.9316C79.5018 55.4031 75.4023 55.4031 72.8739 57.9316C70.3454 60.46 70.3454 64.5595 72.8739 67.088C75.4023 69.6165 79.5018 69.6164 82.0303 67.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.543 33.916H51.742C38.6485 33.916 28.0342 44.5304 28.0342 57.6238V64.4749C28.0342 77.5684 38.6485 88.1828 51.742 88.1828H53.543C66.6365 88.1828 77.2508 77.5684 77.2508 64.4749V57.6238C77.2508 44.5304 66.6365 33.916 53.543 33.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6438 42.1809C59.9333 42.1809 65.8425 39.8072 65.8425 36.879C65.8425 33.9509 59.9333 31.5771 52.6438 31.5771C45.3543 31.5771 39.4451 33.9509 39.4451 36.879C39.4451 39.8072 45.3543 42.1809 52.6438 42.1809Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4648 61.3118C43.7051 59.8315 42.6999 58.4366 41.2195 58.1963C39.7392 57.9561 38.3443 58.9613 38.104 60.4417C37.8637 61.922 38.869 63.3169 40.3493 63.5572C41.8297 63.7975 43.2246 62.7922 43.4648 61.3118Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6799 61.5126C67.0321 60.0548 66.1358 58.5876 64.678 58.2354C63.2202 57.8833 61.7529 58.7796 61.4008 60.2374C61.0486 61.6952 61.945 63.1624 63.4028 63.5146C64.8605 63.8667 66.3278 62.9704 66.6799 61.5126Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6055 66.2051C37.6055 66.2051 44.235 73.4285 52.4116 73.4285C60.5881 73.4285 67.2198 66.2051 67.2198 66.2051H37.6055Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7878 94.083H45.4982C44.2309 94.083 42.9759 94.3326 41.8051 94.8176C40.6342 95.3026 39.5704 96.0134 38.6742 96.9096C37.7781 97.8057 37.0672 98.8696 36.5823 100.04C36.0973 101.211 35.8477 102.466 35.8477 103.734V109.86H41.4895V125.634H69.4405V103.734C69.4405 102.466 69.1908 101.211 68.7057 100.04C68.2206 98.8689 67.5096 97.805 66.6132 96.9088C65.7168 96.0127 64.6527 95.3019 63.4816 94.817C62.3105 94.3321 61.0554 94.0827 59.7878 94.083Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7051 79.1191H58.5805V95.0054C58.5805 96.5799 57.955 98.0899 56.8417 99.2032C55.7284 100.317 54.2184 100.942 52.6439 100.942C51.0694 100.942 49.5594 100.317 48.446 99.2032C47.3327 98.0899 46.7072 96.5799 46.7072 95.0054V79.1191H46.7051Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_43569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    rx: 19.3656,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv1);
export default __webpack_public_path__ + "static/media/Av1.da8e6d755bb8182981b27be768c7e06f.svg";
export { ForwardRef as ReactComponent };